import React, { useState, useEffect } from "react";
import classes from "./SmallSidebar.module.scss";
import MenuIcon from "@material-ui/icons/Menu";
import UserInfo from "components/UserInfo";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userSignOut, setPageTitle } from "../../actions";
import { RiUserFill, RiGroupFill, RiRadarFill } from "react-icons/ri";
import {
  BsFillDiagram3Fill,
  BsChatSquareQuoteFill,
  BsUpload,
  BsXLg,
} from "react-icons/bs";
import { MdWork } from "react-icons/md";
import { useTranslation } from "react-i18next";
import ChangeLang from "./ChangeLang";

export default function SmallSidebar() {
  const { t, i18n } = useTranslation();
  const [widthPx, setWidthPx] = useState("0");
  const dispatch = useDispatch();
  const [isReseller, setIsReseller] = useState(
    JSON.parse(localStorage.getItem("reseller"))
  );

  useEffect(() => {
    setTimeout(() => {
      if (localStorage.getItem("reseller")) {
        setIsReseller(JSON.parse(localStorage.getItem("reseller")));
      }
    }, 500);
  }, []);

  function openNav() {
    setWidthPx("250px");
  }

  function closeNav() {
    setWidthPx("0");
  }

  return (
    <div className={classes.smallSideNavContainer}>
      <button
        className={
          i18n.language === "en" ? classes.openBtnLtr : classes.openBtn
        }
        onClick={() => openNav()}
      >
        <MenuIcon fontSize="large" />
      </button>

      <div
        style={{ width: widthPx }}
        className={
          i18n.language === "en" ? classes.sidePanelLtr : classes.sidePanel
        }
      >
        <div className={classes.section}>
          <ChangeLang />
          <span className={classes.closeBtn} onClick={() => closeNav()}>
            <BsXLg fontSize="22" />
          </span>
          <UserInfo width={180} margin={"0 auto"} />
        </div>
        <div className={classes.section}>
          <NavLink
            to="/app/users"
            onClick={() => {
              closeNav();
              dispatch(setPageTitle("کاربران"));
            }}
            className={classes.menuItem}
          >
            <RiUserFill fontSize="20" />
            &nbsp;&nbsp;
            <span className="nav-text">{t("sidebar.users")}</span>
          </NavLink>
          <NavLink
            to="/app/groups"
            onClick={() => {
              closeNav();
              dispatch(setPageTitle("گروه‌ها"));
            }}
            className={classes.menuItem}
          >
            <RiGroupFill fontSize="20" />
            &nbsp;&nbsp;
            <span className="nav-text">{t("sidebar.groups")}</span>
          </NavLink>
          <NavLink
            to="/app/map"
            onClick={() => {
              closeNav();
              dispatch(setPageTitle("دیسپچینگ"));
            }}
            className={classes.menuItem}
          >
            <RiRadarFill fontSize="20" />
            &nbsp;&nbsp;
            <span className="nav-text">{t("sidebar.dispatching")}</span>
          </NavLink>
          <NavLink
            to="/app/missions"
            onClick={() => {
              closeNav();
              dispatch(setPageTitle("مأموریت‌ها"));
            }}
            className={classes.menuItem}
          >
            <MdWork fontSize="20" />
            &nbsp;&nbsp;
            <span className="nav-text">{t("sidebar.missions")}</span>
          </NavLink>
          <NavLink
            to="/app/chat"
            onClick={() => {
              closeNav();
              dispatch(setPageTitle("گفتگوها"));
            }}
            className={classes.menuItem}
          >
            <BsChatSquareQuoteFill fontSize="20" />
            &nbsp;&nbsp;
            <span className="nav-text">{t("sidebar.chats")}</span>
          </NavLink>
          {isReseller === true && (
            <NavLink
              to="/app/tenant"
              onClick={() => {
                closeNav();
                dispatch(setPageTitle("زیرمجموعه‌ها"));
              }}
              className={classes.menuItem}
            >
              <BsFillDiagram3Fill fontSize="20" />
              &nbsp;&nbsp;
              <span className="nav-text">{t("sidebar.tenant")}</span>
            </NavLink>
          )}
        </div>
        <div className={classes.section}>
          <NavLink
            to=""
            className={classes.menuItem}
            onClick={() => {
              dispatch(userSignOut());
            }}
          >
            <BsUpload fontSize={"20"} style={{ transform: `rotate(90deg)` }} />
            &nbsp;&nbsp;
            <span className="nav-text">{t("sidebar.exit")}</span>
          </NavLink>
        </div>
      </div>
    </div>
  );
}
